<template>
  <div>
    <rabbey-toolbox>
      <div class="mr-5 box">
        <yearcomponent
          ref="yearC"
          @change="handler_year"
          v-model="year"
        ></yearcomponent>
      </div>
    </rabbey-toolbox>

    <el-row>
      <el-col>
        <rabbey-table-3
          show-summary
          v-loading="principalTable"
          :columns="columns2"
          :data="technicalTracker"
          :summary-method="getTotalByMonthSLA"
        />
      </el-col>
    </el-row>
    <div>
      <!-- table detalle por Vendedor -->
      <DetailTechnicalSupportKpi ref="details2" />
    </div>
  </div>
</template>

<script>
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import {
  MonthsRabbey3,
  commentColumns
} from "@/helpers/TechnicalSupportColumns";
import { getTotalByMonthSLA } from "@/helpers/TableRabbeyTools";
import DetailTechnicalSupportKpi from "./DetailTechnicalSupportKpi.vue";
import { formatArrayToElSelect } from "@/utils";
import ImagePerson from "@/components/functionals/ImagePerson.vue";

export default {
  name: "KpiSoporteTecnico",
  components: { DetailTechnicalSupportKpi, yearcomponent },
  data() {
    return {
      deparmentId: "",
      employeeId: "",
      serviceTypeID: "",
      directionIdFilter: "",

      directionId: 0,
      serviceTypeList: [],
      loading: false,
      deparments: [],
      directions: [],
      employees: [],
      principalTable: true,
      loadingDetails: true,
      deals: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",
      TypeAgent: "customerservice",
      contacts: [],
      loadingContacts: false,
      month: "",
      MontlyTarget: "",
      AccountNumber: "",
      product: 0,
      InvoiceNum: "",
      ContactEmail: "",
      ProductList: [],
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },
      columns: [
        {
          prop: "tecnico",
          name: "Tecnico",
          minWidth: 220,
          fixed: true
        }
      ],
      columns2: [
        {
          prop: "technical",
          label: "Tecnico",
          minWidth: 220,
          fixed: true,
          formatter: ImagePerson,
          attrs: {
            imgKey: "TechPhoto"
          }
        },
        ...this.mapOb(MonthsRabbey3)
      ],
      columnsComments: [...commentColumns],
      items: [],
      comments: [],
      Dcoments: false,
      commentloading: false,
      slaTracker: {
        Failed: 0,
        Compliment: 1
      },
      technicalTracker: []
    };
  },
  mounted() {
    this.$refs.yearC.Year = this.year;
  },
  created() {
    this.getData();
  },

  methods: {
    getTotalByMonthSLA,
    formatArrayToElSelect,
    getPorcentajeByUserAndMonth(month, techinicalName, year) {
      const KpiTechnicalSupport = this.groupItems[techinicalName];
      if (KpiTechnicalSupport === undefined) {
        return 0;
      }

      let countCompliment = 0;
      let countFailed = 0;
      for (let index = 0; index < KpiTechnicalSupport.length; index++) {
        const element = KpiTechnicalSupport[index];
        const createdAt = this.$moment(
          element.CreatedAt,
          "YYYY-MM-DDTHH:mm:ss.SSS"
        );
        const elementMonth = createdAt.format("M");
        const elementYear = createdAt.format("YYYY");

        if (
          month === elementMonth &&
          year === elementYear &&
          element.SLA === this.slaTracker.Compliment
        ) {
          countCompliment++;
        }

        if (
          month === elementMonth &&
          year === elementYear &&
          element.SLA === this.slaTracker.Failed
        ) {
          countFailed++;
        }
      }

      const suma = countCompliment + countFailed;
      let Porcentaje = suma > 0 ? (countCompliment / suma) * 100 : 0;

      return Porcentaje;
    },
    openDetail2(mes, row) {
      this.$refs.details2.show(row, mes, this.year);
    },
    getProductSelected() {
      return this.product;
    },
    getServiceTypeSelected() {
      return this.serviceTypeID;
    },
    mapOb(data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.cellAtrrs = {
          getProductSelected: this.getProductSelected,
          getServiceTypeSelected: this.getServiceTypeSelected,
          openDetail: this.openDetail2,
          ...element.cellAtrrs
        };
      }
      return data;
    },
    handler_year(_year) {
      this.year = _year;
      this.getData();
    },

    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
    },
    getData() {
      let params = {
        year: this.year,
        companyID: this.currentCompany,
        product: this.product,
        serviceTypeID: this.serviceTypeID,
        directionId: this.directionId ? this.directionId : 0,
        employeeId: this.employeeId ? this.employeeId : 0,
        deparmentId: this.deparmentId ? this.deparmentId : 0
      };
      this.$store.commit("rabbey_table/loading");
      this.$http
        .get("/api/KpiTechnicalSupport/GetKpiSupportInternal", {
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.$store.commit("rabbey_table/items", data);
          const technicalsGroup = this._.groupBy(data, "Name");
          const TechPhotoGroup = this._.groupBy(data, "TechPhoto");

          let t = {};
          this.technicalTracker = [];
          const technicals = Object.keys(technicalsGroup);
          const TechPhotos = Object.keys(TechPhotoGroup);

          for (let index = 0; index < technicals.length; index++) {
            const techinicalName = technicals[index];
            const TechPhoto = TechPhotos[index];

            t = {
              technicalId: 0,
              technical: techinicalName,
              1: 0,
              2: 0,
              3: 0,
              4: 0,
              5: 0,
              6: 0,
              7: 0,
              8: 0,
              9: 0,
              10: 0,
              11: 0,
              12: 0,
              TechPhoto: TechPhoto,
              DirecctionID: 0,
              total: 0
            };

            const solicitudes = technicalsGroup[techinicalName];
            const primeraSolicitud = solicitudes[0];
            const createdAt = this.$moment(
              primeraSolicitud.CreatedAt,
              "YYYY-MM-DDTHH:mm:ss.SSS"
            );
            const year = parseInt(createdAt.format("YYYY"));
            t.technicalId = primeraSolicitud.tecnicoID;
            t.DirecctionID = primeraSolicitud.DirecctionID;
            let monthTracker = {
              1: {
                Compliment: 0,
                Failed: 0
              },
              2: {
                Compliment: 0,
                Failed: 0
              },
              3: {
                Compliment: 0,
                Failed: 0
              },
              4: {
                Compliment: 0,
                Failed: 0
              },
              5: {
                Compliment: 0,
                Failed: 0
              },
              6: {
                Compliment: 0,
                Failed: 0
              },
              7: {
                Compliment: 0,
                Failed: 0
              },
              8: {
                Compliment: 0,
                Failed: 0
              },
              9: {
                Compliment: 0,
                Failed: 0
              },
              10: {
                Compliment: 0,
                Failed: 0
              },
              11: {
                Compliment: 0,
                Failed: 0
              },
              12: {
                Compliment: 0,
                Failed: 0
              }
            };

            for (let index = 0; index < solicitudes.length; index++) {
              const solicitud = solicitudes[index];
              const createdAt = this.$moment(
                solicitud.CreatedAt,
                "YYYY-MM-DDTHH:mm:ss.SSS"
              );
              const elementMonth = parseInt(createdAt.format("M"));
              const elementYear = parseInt(createdAt.format("YYYY"));

              for (let month = 1; month < 13; month++) {
                if (month === elementMonth && year === elementYear) {
                  if (solicitud.SLA === this.slaTracker.Compliment) {
                    monthTracker[month].Compliment++;
                  } else if (solicitud.SLA === this.slaTracker.Failed) {
                    monthTracker[month].Failed++;
                  }
                }
              }
            }

            let c = 0;
            let f = 0;
            for (let month = 1; month < 13; month++) {
              const { Compliment, Failed } = monthTracker[month];
              c += Compliment;
              f += Failed;
              const sum = Compliment + Failed;

              t[`${month}`] = sum > 0 ? (Compliment / sum) * 100 : 0;
            }
            const sumTotal = c + f;
            t.total = sumTotal > 0 ? (c / sumTotal) * 100 : 0;

            this.technicalTracker.push(t);
          }
        })
        .finally(() => {
          this.$store.commit("rabbey_table/success");
          this.principalTable = false;
        });
    }
  }
};
</script>

<style>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
